// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const HubNano2 = ({ fill, svgComponents: { Circle, G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    /*eslint-disable max-len */
    return (
        <G {...gProps}>
            <Path d="M33.52,36h-27A2.48,2.48,0,0,1,4,33.52v-27A2.48,2.48,0,0,1,6.48,4h27A2.48,2.48,0,0,1,36,6.48v27A2.48,2.48,0,0,1,33.52,36ZM6.48,5A1.48,1.48,0,0,0,5,6.48v27A1.48,1.48,0,0,0,6.48,35h27A1.48,1.48,0,0,0,35,33.52v-27A1.48,1.48,0,0,0,33.52,5Z" />
            <Path d="M29.43,9.07a1.49,1.49,0,0,1,1.5,1.55V28.92c0,1.86-.68,2-1.5,2H23.2a4.52,4.52,0,0,1-2.48-.64,14.81,14.81,0,0,0-2.36-1,22.59,22.59,0,0,0-4.74-1h-3a1.85,1.85,0,0,1-1.55-1.66v-16a1.56,1.56,0,0,1,1.56-1.56h18.8m0-1H10.63a2.56,2.56,0,0,0-2.56,2.56v16a2.82,2.82,0,0,0,2.55,2.66h2.94a21.7,21.7,0,0,1,4.5,1,13.77,13.77,0,0,1,2.22.92,5.5,5.5,0,0,0,2.93.74h6.23c1.37,0,2.5-.6,2.5-3V10.63a2.48,2.48,0,0,0-2.5-2.55Z" />
            <Circle cx="27.04" cy="12.96" r="1.98" />
            <Circle cx="27.04" cy="18.24" r="1.98" />
            <Circle cx="27.04" cy="23.52" r="1.98" />
        </G>
    );
    /*eslint-enable max-len */
};

export default HubNano2;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/devices/hub-nano2/index.js